module.exports = __webpack_public_path__ + "media/src/images/award_land_der_ideen-0694c7268fe9d5db73f15862d52bcb8a.jpg";